import WalletModal from "./WalletModal";

export default WalletModal;
